module.exports = __webpack_public_path__ + "media/svg-new/astronauto-3fc638ef.svg";